<div class="added-role-dialog">
  <img
    src="assets/img/success-image.svg"
    alt="Success icon"
    class="success-icon">
  <h2 class="headline">{{'PAYMENT_LINK_PAGE.MODAL_DELETE_SUCCESS.TITLE' | translate}}</h2>
  <div class="btn-block">
    <button
      (click)="closeModal()"
      class="btn btn-link">
      {{'PAYMENT_LINK_PAGE.MODAL_DELETE_SUCCESS.GO_TO_PAYLINK' | translate}}
    </button>
  </div>
</div>
